import { PaysafeTokenizationResponse } from '../../models/paysafe/paysafe-tokenization-response.interface';

export const mockPaysafeTokenizationResponse: PaysafeTokenizationResponse = {
  token: 'token',
};
